import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  FormControl,
  Textarea,
  useToast,
  Input,
  Stack,
  Text,
  Table,
  Tr,
  Th,
  Tbody,
  Td,
} from '@chakra-ui/react'
import { useQuery } from 'react-query'
import { api } from '../../../../services/api'
import { memo } from 'react'
import { ptBR } from 'date-fns/locale'

export const InfoSolicitaTroca = memo(({ numeroNota }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  console.log(numeroNota)

  const { data } = useQuery(['info-solicita-troca', numeroNota], async () => {
    const response = await api.get(`/site/v2/crm-controle/lista-trocas-pedido/${numeroNota}`)
    return response.data
  }, {
    staleTime: 1000 * 60 * 10,
  })

  console.log(data)


  return (
    <>
      <Button onClick={onOpen} colorScheme="blue" size="sm" display={'flex'} mx="auto" mb="10px"
        alignItems={'center'} justifyContent={'center'}
      >
        <Text fontSize="2rem">+</Text>
      </Button>
      <Modal
        onClose={onClose}
        isOpen={isOpen}
        isCentered
        size="xl"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Text fontSize="1rem">{numeroNota}</Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Table size="sm">
              <Tr>
                <Th>Data da troca</Th>
              </Tr>
              <Tbody>
                <Tr>
                  <Td>
                  {data?.datas_troca?.map((dataString) => (

                    //format date 2023-11-17 15:03:16.317
                    <Text key={dataString}>
                      {new Date(dataString).toLocaleDateString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                      })}
                    </Text>
                  ))}
                  </Td>
                </Tr>
              </Tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
       
            <Button variant="ghost">Cancelar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
)
